export default __webpack_public_path__ + "static/b6-4919b3168d75d8317cca7be1e1461751.png";